import { OnboardingFulfilledBy } from '@nemuru-eng/js-api-client';

import { DYNAMIC_PAGE_PATHS } from '../components/views/DynamicPageView/config/shared/pathRoutes';

export const getDynamicPagePathByOnboardingFulfilledBy = (onboardingFulfilledBy: OnboardingFulfilledBy) => {
  switch (onboardingFulfilledBy) {
    case OnboardingFulfilledBy.BORROWER_ONLINE:
      return DYNAMIC_PAGE_PATHS.ORDER;
    case OnboardingFulfilledBy.PAY_BY_LINK:
      return DYNAMIC_PAGE_PATHS.PAY_BY_LINK;
    default:
      return DYNAMIC_PAGE_PATHS.ORDER;
  }
};
